<div #search class="search">
    <div class="clearfix legendWideControlGroup text-container">
        <input class="pull-right" type="text" [(ngModel)]="text" (click)="textboxClick()"
            (ngModelChange)="onTextboxChange()" placeholder="{{placeHolder}}">
    </div>
    <div class="results-container" [hidden]="!hasFocus">
        <div class="loading" *ngIf="loading">
            Loading...
        </div>
        <div class="error" *ngIf="error">
            Error performing search.
        </div>
        <div class="results" *ngIf="!loading && typeResults.length">
            <div class="types">
                <div *ngFor="let type of typeResults; let i = index" class="type" (click)="selectType(type.name)"
                    [class.selected]="type.name === selectedTypeName">
                    {{ type.pluralDisplayName }} ({{ type.count }})
                </div>
            </div>
            <div class="type-results">
                <div *ngFor="let type of typeResults; let i = index" class="type"
                     [hidden]="type.name !== selectedTypeName">
                    <ng-container *ngIf="point && selectedTypeName === 'feature'">
                        <div class="result" style="cursor: default;">
                            <div><span class="icon-ui-map-pin"></span> Point: {{ point.latitude }} , {{ point.longitude }}</div>
                            <br>
                            <button class="btn btn-success" (click)="showLatLongOnMap()">Add to Map</button>&nbsp;&nbsp;
                            <button class="btn btn-danger" (click)="cancelPointOnMap()">Cancel</button>
                        </div>
                    </ng-container>
                    <div *ngFor="let result of results[type.name]; let i = index"
                         (click)="addResultToMap(result, i)" class="result" [attr.title]="result.description ? result.description : null">
                        <div>{{ result.primaryText }}</div>
                        <div>{{ result.secondaryText }}</div>
                        <div>{{ result.layerTitle }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
